var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8e6c9",
    d: "M40 13L30 13 30 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M30 13L40 23 40 13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8f5e9",
    d: "M31,23H17h-2v2v2v2v2v2v2v2h18v-2v-2v-2v-2v-2v-2v-2H31z M17,25h4v2h-4V25z M17,29h4v2h-4V29z M17,33h4v2h-4V33z M31,35h-8v-2h8V35z M31,31h-8v-2h8V31z M31,27h-8v-2h8V27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheets);
export default __webpack_public_path__ + "static/media/sheets.96d2afb774e8f4c8d816a14e8aee3ce5.svg";
export { ForwardRef as ReactComponent };